import React from 'react';
import { SmileySad } from '@phosphor-icons/react';

import { Button } from '../../components/general';

import { URL } from '../../constants';
import { PageError } from '../../types';
import { goTo, getHelpUrl } from '../../utils';

interface Props {
  code: PageError;
}

const Error: React.FC<Props> = (props) => {
  const { code } = props;

  let heading = null;
  let subheading = null;

  if (code === 403) {
    heading = 'Access denied';
    subheading =
      'It seems this page is in a restricted zone. Your clearance level doesn’t quite reach this orbit. Head back to friendlier skies!';
  } else if (code === 404) {
    heading = 'Page not found';
    subheading =
      'Oops, the page you’re looking for has vanished into the galaxy. Let’s get you back to home base, safe and sound.';
  }

  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-8 text-center">
      <h1 className="text-4xl bg-gradient-primary-right bg-clip-text text-transparent">
        {code || (
          <SmileySad
            weight="fill"
            className="fill-[url('#icon-primary-gradient')]"
            size={100}
          />
        )}
      </h1>

      {heading && <h2>{heading}</h2>}

      {subheading && <div className="w-full sm:w-1/2">{subheading}</div>}

      <div className="w-full flex justify-center gap-4">
        <Button onClick={() => goTo(URL.HOME)} className="w-1/2 sm:w-40">
          Return Home
        </Button>

        <Button
          onClick={() => goTo(getHelpUrl())}
          colour="pink"
          className="w-1/2 sm:w-40"
        >
          Help
        </Button>
      </div>
    </div>
  );
};

export default Error;
